import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "../css/main.scss";
import productData from "../Datas/productData";

function Main() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="main">
      <Header />

      <main>
        <section className="hero-banner">
          <div className="hero-content">
            <h1>The Outdoor Sale</h1>
            <Link to="/shop" className="hero-button" onClick={toTop}>
              Save up to 25%
            </Link>
          </div>
        </section>

        <section className="outdoor-categories">
          <div className="outdoor-categories__inner">
            <h2 className="outdoor-categories__title">
              Live, dine, and gather outside
            </h2>
            <div className="outdoor-categories__grid">
              <Link
                to="/shop"
                className="outdoor-category-card"
                onClick={toTop}
              >
                <img
                  src="/main/main2-1.avif"
                  alt="Dining"
                  loading="lazy"
                  width="200"
                  height="110"
                />
                <span>DINING</span>
              </Link>
              <Link
                to="/shop"
                className="outdoor-category-card"
                onClick={toTop}
              >
                <img
                  src="/main/main2-2.avif"
                  alt="Lounge Chairs"
                  loading="lazy"
                  width="200"
                  height="110"
                />
                <span>LOUNGE CHAIRS</span>
              </Link>
              <Link
                to="/shop"
                className="outdoor-category-card"
                onClick={toTop}
              >
                <img
                  src="/main/main2-3.avif"
                  alt="Coffee Tables"
                  loading="lazy"
                  width="200"
                  height="110"
                />
                <span>COFFEE TABLES</span>
              </Link>
              <Link
                to="/shop"
                className="outdoor-category-card"
                onClick={toTop}
              >
                <img
                  src="/main/main2-4.avif"
                  alt="Sofas + Sectionals"
                  loading="lazy"
                  width="200"
                  height="110"
                />
                <span>SOFAS + SECTIONALS</span>
              </Link>
              <Link
                to="/shop"
                className="outdoor-category-card"
                onClick={toTop}
              >
                <img
                  src="/main/main2-5.avif"
                  alt="Umbrellas"
                  loading="lazy"
                  width="200"
                  height="110"
                />
                <span>UMBRELLAS</span>
              </Link>
            </div>
          </div>
        </section>

        <section className="feature-sculptura">
          <div className="feature-sculptura__inner">
            <div className="feature-sculptura__media">
              <img
                src="/main/main3-1.avif"
                alt="Sculptura"
                loading="lazy"
                width="800"
                height="600"
              />
              <div className="feature-sculptura__badge" aria-hidden="true" />
            </div>
            <div className="feature-sculptura__content">
              <div className="feature-sculptura__eyebrow">
                70 YEARS OF SCULPTURA
              </div>
              <h2 className="feature-sculptura__title">Whatever the weather</h2>
              <p className="feature-sculptura__copy">
                Founded in Michigan in 1866, Woodard Furniture Company has long
                shaped the evolution of outdoor living. In 1956, it introduced
                the Sculptura Chair – an iron mesh design by Russell Woodard
                that fused craft with modernism. Now, 70 years later, Sculptura
                arrives in new styles and colors, honoring its legacy while
                speaking to contemporary taste.
              </p>
              <Link
                to="/shop"
                className="feature-sculptura__cta"
                onClick={toTop}
              >
                25% Off Sculptura Collection
              </Link>
            </div>
          </div>
        </section>

        <section className="sale-products">
          <div className="sale-products__inner">
            <h2 className="sale-products__title">Save up to 25%</h2>
            <div className="sale-products__track">
              {productData.slice(0, 4).map((product, index) => {
                const rawPrice = Number(product.price);
                const originalPrice = Number.isFinite(rawPrice) ? rawPrice : 0;
                const salePrice = Number.isFinite(rawPrice)
                  ? rawPrice * 0.75
                  : 0;

                const brand =
                  (product.name || "").startsWith("HAY") ||
                  (product.name || "").includes("HAY")
                    ? "HAY"
                    : (product.name || "").includes("Woodard")
                    ? "Woodard Furniture Company"
                    : "Denowl";

                const colorsCount = Array.isArray(product.colors)
                  ? product.colors.length
                  : 0;
                const isNew = product.id % 3 === 0;

                const primaryImageSrc = (product.image || "")
                  .replace(".jpeg", ".avif")
                  .replace(".jpg", ".avif")
                  .replace(".png", ".avif");

                return (
                  <Link
                    key={product.id}
                    to={`/shopDetails/${product.id}`}
                    className={`sale-product ${index === 0 ? "is-first" : ""}`}
                    onClick={toTop}
                  >
                    <div className="sale-product__image">
                      <img
                        src={primaryImageSrc}
                        alt={product.name}
                        loading="lazy"
                        decoding="async"
                        width="240"
                        height="210"
                        onError={(e) => {
                          e.currentTarget.onerror = null;
                          e.currentTarget.src = product.image;
                        }}
                      />
                    </div>
                    <div className="sale-product__meta">
                      <div className="sale-product__brand">{brand}</div>
                      <div className="sale-product__name">{product.name}</div>
                      <div className="sale-product__prices">
                        <span className="sale-product__priceOriginal">
                          $
                          {originalPrice.toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </span>
                        <span className="sale-product__priceSale">
                          $
                          {salePrice.toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </span>
                      </div>
                      <div className="sale-product__discount">25% off</div>
                      <div className="sale-product__colors">
                        {colorsCount} Colors
                      </div>
                      {isNew && (
                        <div className="sale-product__new">NEW ARRIVAL</div>
                      )}
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
        </section>

        <section className="help-links">
          <div className="help-links__inner">
            <h2 className="help-links__title">We're here to help</h2>
            <div className="help-links__grid">
              <Link to="/contact" className="help-card" onClick={toTop}>
                <img
                  src="/main/main4-1.avif"
                  alt="Contact Us"
                  loading="lazy"
                  decoding="async"
                  width="220"
                  height="140"
                />
                <span>Contact Us</span>
              </Link>
              <Link to="/shipping" className="help-card" onClick={toTop}>
                <img
                  src="/main/main4-2.avif"
                  alt="Product Care"
                  loading="lazy"
                  decoding="async"
                  width="220"
                  height="140"
                />
                <span>Product Care</span>
              </Link>
              <Link to="/contact" className="help-card" onClick={toTop}>
                <img
                  src="/main/main4-3.avif"
                  alt="Design Concierge"
                  loading="lazy"
                  decoding="async"
                  width="220"
                  height="140"
                />
                <span>Design Concierge</span>
              </Link>
              <Link to="/returns" className="help-card" onClick={toTop}>
                <img
                  src="/main/main4-4.avif"
                  alt="Shipping + Returns"
                  loading="lazy"
                  decoding="async"
                  width="220"
                  height="140"
                />
                <span>Shipping + Returns</span>
              </Link>
              <Link to="/about" className="help-card" onClick={toTop}>
                <img
                  src="/main/main4-5.avif"
                  alt="Visit a Studio"
                  loading="lazy"
                  decoding="async"
                  width="220"
                  height="140"
                />
                <span>Visit a Studio</span>
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Main;
